<template>
    <main-layout>
        <app-header icon="tool">
            Planning
        </app-header>

        <div class="cols nav-planning">
            <router-link class="btn prev btn-full" :to="{name: 'agenda'}" style="margin-bottom: 10px;">
                <i class="icon-go"></i>
                Retour
            </router-link>
        </div>

        <template>
            <div id="list-events" class="list" v-for="event in events">
                <div class="fi-item">
                    <a :href="`#/agenda?date=${event.start}`" class="list-item wrap">
                        <strong class="title">{{ event.title }}</strong>
                        <br>
                        <span class="date" style="margin-bottom: 5px">
                            Du {{ event.start|dateFormat('DD/MM/YYYY HH:mm') }} au {{ event.end|dateFormat('DD/MM/YYYY HH:mm') }}
                        </span>
                        <div class="list-installs" style="margin-bottom: 5px" v-for="install in event.installs">
                            <span class="install-nom" style="font-weight: bold">{{ install.nom }}</span>
                            <span class="install-modele" style="font-weight: bold;">{{ install.modele }} {{ install.marque }}</span>
                            <span class="commentaire" style="text-transform: lowercase; font-weight: revert">
                                {{ install.commentaire }}
                            </span>
                        </div>
                        <br>
                        <span class="commentaire" v-if="event.body">
                            <strong style="font-size: 16px">Commentaire : </strong><br>
                            <span class="commentaire" style="text-transform: lowercase; font-weight: revert">{{ event.body }}</span>
                        </span>
                    </a>
                </div>

            </div>

        </template>

    </main-layout>
</template>

<script>

import localforage from "localforage";

export default {


    data() {
        return {
            events: [],
            dateCat: null
        }
    },

    methods: {

        getEvents() {
            localforage
                .getItem('listEvents')
                .then(events => {
                    events = JSON.parse(events);
                    let listingDate = [];
                    let now = new Date();
                    let start = null;
                    let end = null;

                    events.forEach(function (event){
                        start = new Date(event.start);
                        end = new Date(event.end);

                        if((start < now && end > now) || (start > now && end > now)){
                            //On enlève l'icone du comment ;)
                            event.title = event.title.replace('💬 ', '');
                            listingDate.push(event)
                        }
                    })

                    this.events = listingDate;
                }).catch(err => {
            })
        }

    },

    mounted() {

        this.getEvents();

    }
}

</script>

<style>

#list-events .list-item {
    display: block;
    position: relative;
    background-color: #eee;
    padding: 10px;
    margin-bottom: 10px;
    text-transform: uppercase;
    text-decoration: none;
}

#list-events .list-item strong {
    color: #000000;
    font-size: 2.3rem;
    font-weight: 700;
}

#list-events .list-item span.date {
    color: #999999;
    font-size: 1.5rem;
    font-weight: 400;
}

#list-events .list-item span.commentaire {
    color: #333333;
    font-size: 1.5rem;
    font-weight: 700;
}

#list-events .list-item:after {
    content: '\e909';
    font-family: 'fi360' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    font-size: 3.3rem;
    position: absolute;
    right: 10px;
    top: 30px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    color: #5698d2;
}

#list-events .list-item{
    margin-bottom:0;
}

div.fi-item {
    display: flex;
    flex-direction: row;
    align-content: space-between;
    align-items: center;
    justify-content: center;
    background-color: #eee;
    margin-bottom: 10px;
}

a.btn.del-fi{
    width:40px;
    height:40px;
    margin-right:20px;
    background-color: #c31616;
    text-align:center;
}

a.btn.del-fi i {
    color: #ffffff;
    font-size: 2.2rem;
    text-align: center;
    left: 0;
    right: 0;
}

</style>



// WEBPACK FOOTER //
// ListeEvents.vue?7bb74d2c